import { useQuery } from "@tanstack/react-query"
import { DeviceRolePermissionGet } from "../app/models/DeviceRolePermission"
import { digitalManagerApi } from "../services/api"

export function useDeviceRolePermissions(deviceId?: string, roleId?: string) {
  const { data: deviceRolePermissions = [], isLoading: isLoadingDeviceRolePermissions } =
    useQuery({
      queryKey: ["deviceRolePermissions", deviceId, roleId],
      queryFn: () =>
        digitalManagerApi
          .get<
            DeviceRolePermissionGet[]
          >(`/devices/${deviceId}/roles/${roleId}/permissions`)
          .then((r) => r.data),
      enabled: !!deviceId && !!roleId,
    })

  return {
    deviceRolePermissions,
    isLoadingDeviceRolePermissions,
  }
}
